import { ApiType } from "@gymflow/common/lib/api/ApiType";
import { useQuery } from "@tanstack/react-query";

import { memberAsMemberQueryKeys } from "./memberAsMemberQueryKeys";

export const useQueryGetInvoiceByInvoiceNumberAsMember = ({
  api,
  invoiceNumber,
  enabled,
}: {
  api: ApiType;
  invoiceNumber: string;
  enabled: boolean;
}) =>
  useQuery({
    queryKey: memberAsMemberQueryKeys.getInvoiceByInvoiceNumber(invoiceNumber),
    queryFn: async () =>
      (await api.profileApi.getInvoiceByInvoiceNumber(invoiceNumber)).data,
    enabled,
  });
